export default __webpack_public_path__ + "media/images/landing-115-569x465-eeea256601efd972d4a998e8b6a44a4c.jpg";